export function generateCase(x: number) {
  // generate case id
  return Array(x)
    .fill('123456789abcdefghijklmnopqrstuvwxyz')
    .map((x) => x[Math.floor(Math.random() * x.length)])
    .join('');
}
